export const scrollToId = (id) => {
  window.scroll({
    behavior: 'smooth',
    top: document.getElementById(id)?.offsetTop,
  })
}
